import React, { useCallback, useEffect, useState } from 'react';
import { BlockStack, Card, Modal, TextField } from '@shopify/polaris';
import TextFieldRichText from 'components/TextFieldRichText';
import { SaveIcon } from '@shopify/polaris-icons';
import { TypedFaq, useCreateFaq, useGetFaq, useUpdateFaq } from 'queries/faq.query';
import { lengthLessThan, lengthMoreThan, notEmptyString, useField, useForm } from '@shopify/react-form';
export default function FaqCreateOrUpdateModal({
  show,
  current_faq_id,
  onClose
}: {
  show: boolean;
  current_faq_id?: any;
  onClose: () => void;
}) {
  // Mutation to add a new FAQ
  const {
    mutateAsync: createFaq,
    isPending: isAdding
  } = useCreateFaq();
  const {
    mutateAsync: updateFaq,
    isPending: isUpdating
  } = useUpdateFaq();
  const {
    mutateAsync: getEntity,
    data: entity
  } = useGetFaq();
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (show) setShowModal(true);
  }, [show]);
  useEffect(() => {
    if (showModal && current_faq_id) {
      getEntity(current_faq_id);
    }
  }, [current_faq_id, showModal]);

  /**
   * Khai báo field cho form!
   */
  const useFields = {
    question: useField<string>({
      value: entity ? entity.question : '',
      validates: [notEmptyString('Trường này không được để trống.'), lengthLessThan(255, 'Câu hỏi quá dài!'), lengthMoreThan(1, 'Câu hỏi quá ngắn!')]
    }),
    answer: useField<string>({
      value: entity ? entity.answer : '',
      validates: [notEmptyString('Trường này không được để trống.'), lengthMoreThan(1, 'Câu trả lời quá ngắn!'), lengthLessThan(65000, 'Câu trả lời quá dài!')]
    })
  };
  const closeModalCallback = useCallback(() => {
    useFields.answer.onChange('');
    useFields.question.onChange('');
    setShowModal(false);
    onClose();
  }, [useFields]);
  const {
    fields,
    submit
  } = useForm({
    makeCleanAfterSubmit: true,
    fields: useFields,
    async onSubmit(values) {
      if (current_faq_id) {
        await updateFaq({
          id: current_faq_id,
          question: values.question,
          answer: values.answer
        }).then(() => {
          closeModalCallback();
        }).catch();
      } else {
        await createFaq({
          question: values.question.trim(),
          answer: values.answer.trim(),
          question_order: 0
        }).then(() => {
          closeModalCallback();
        }).catch();
      }
      return {
        status: 'success'
      };
    }
  });
  return <Modal open={showModal} title={current_faq_id ? 'Cập nhật' : 'Tạo hỏi đáp mới'} onClose={closeModalCallback} primaryAction={{
    content: current_faq_id ? 'Cập nhật' : 'Lưu lại',
    icon: SaveIcon,
    onAction: () => submit(),
    loading: isAdding || isUpdating
  }}>
      <Modal.Section>
        <BlockStack gap="400">
          <TextField autoComplete="off" label="Câu hỏi" placeholder="Enter your question" {...fields.question} />
          <TextFieldRichText label={'Câu trả lời'} error={fields.answer.error} initialData={fields.answer.value} onCallback={t => fields.answer.onChange(t)} />
        </BlockStack>
      </Modal.Section>
    </Modal>;
}